
import React, { useState } from 'react';
import { LanguageProvider } from './components/LanguageContext';
import TopBar from './components/TopBar';
import NavBar from './components/NavBar';
import Hero from './components/Hero';
import AttorneySection from './components/AttorneySection';
import TrustSignals from './components/TrustSignals';
import PracticeAreas from './components/PracticeAreas';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import StaticPage from './components/StaticPage';
import { ViewType } from './types';

const App: React.FC = () => {
  const [currentView, setCurrentView] = useState<ViewType>('home');

  const handleNavigate = (view: ViewType) => {
    setCurrentView(view);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <LanguageProvider>
      <div className="min-h-screen flex flex-col selection:bg-[#c5a059] selection:text-white">
        <TopBar />
        <NavBar onNavigate={handleNavigate} currentView={currentView} />
        
        <main className="flex-grow">
          {currentView === 'home' ? (
            <>
              <Hero />
              <TrustSignals />
              <AttorneySection />
              <PracticeAreas onNavigate={handleNavigate} />
              <ContactSection />
            </>
          ) : (
            <StaticPage view={currentView} onBack={() => handleNavigate('home')} />
          )}
        </main>

        <Footer onNavigate={handleNavigate} />
        <WhatsAppButton />
      </div>
    </LanguageProvider>
  );
};

export default App;
